import { generatePath } from 'react-router';

import { APPLICATION_ROUTES } from './routes';

export const generateWorkflowPath = (
  shortId: string,
  workflowName: string,
  place?: string,
): string => {
  if (place) {
    return generatePath(APPLICATION_ROUTES.workflowStepPlace.path, {
      document: shortId,
      workflow: workflowName,
      place,
    });
  }
  return generatePath(APPLICATION_ROUTES.workflowStep.path, {
    document: shortId,
    workflow: workflowName,
  });
};
